import { gql } from "apollo-angular";

const CREATE_CONVERSATION = gql`
  mutation createConversation($createConversationInput: CreateConversationInput!) {
    createConversation(createConversationInput: $createConversationInput) {
      id
      name
      type
      status
      description
      launchURL
      tags
      parameters
      createdAt
      updatedAt
    }
  }
`;

const ASSET_EVENT_SUBSCRIPTION = gql`
  subscription OnAssetEvent($conversationId: String!) {
    onAssetEvent(conversationId: $conversationId) {
      conversationId
      assetType
      assetId
      creator
      creatorProfileUrl
      timestamp
      parameters
    }
  }
`;

export { CREATE_CONVERSATION, ASSET_EVENT_SUBSCRIPTION };